export default class TestimonialCarousel {
    constructor() {
        if ($('.testimonial-carousel')[0]) {
      
          $('.testimonial-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            appendDots: $('.testimonial-carousel-dots'),
          });
        }
    }
}

new TestimonialCarousel();


// WEBPACK FOOTER //
// ../views/modules/testimonial-carousel/assets/js/testimonial-carousel.js